import type { BindingType, Effect } from './effect';
import { textEffect } from './text-effect';
import { imageEffect } from './image-effect';
import { collectionEffect } from './collection-effect';
import { fillColorEffect } from './fill-color-effect';

// Add a new bindingType by writing an Effect and registering it here.
export const EFFECTS: Record<BindingType, Effect> = {
  text: textEffect,
  'image-replace': imageEffect,
  'group-collection': collectionEffect,
  'fill-color': fillColorEffect
};
